module.exports = __webpack_public_path__ + "media/application/images/partners/eu-1b90f32111bd233c010cc9b61d18d74878afce9f2176de64c7b7fbde929f387a.png";